import { useForm, zodResolver } from '@mantine/form';
import { useState } from 'react';

import { TSDListItem, TSDSimulatorActivationPayload, TSDSimulatorActivationPayloadSchema } from '@e-origin/contracts';

interface UseSimulatorFormInitializerProps {
  tsd: TSDListItem;
  onHide(): void;
  onSubmit(payload?: Record<string, unknown>): Promise<void> | void;
}

export const useSimulateTsdActivationFormInitializer = ({ onHide, onSubmit }: UseSimulatorFormInitializerProps) => {
  const [submitting, setSubmitting] = useState(false);

  const form = useForm<TSDSimulatorActivationPayload>({
    mode: 'controlled',
    initialValues: {
      status: '02',
    },
    validate: zodResolver(TSDSimulatorActivationPayloadSchema),
    validateInputOnBlur: true,
  });

  const onSubmitForm = async (values: TSDSimulatorActivationPayload) => {
    try {
      setSubmitting(true);

      await onSubmit({
        status: values.status,
      });
    } catch {
      // toast handled by mutation
    } finally {
      setSubmitting(false);
      onHide();
    }
  };

  return {
    form,
    onSubmit: onSubmitForm,
    submitting,
  };
};
